import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
import { GuideFooter } from '../GuideFooter';
import { Sidebar } from './Sidebar';
const StyledSidebarContent = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: ${SkapaTokens.space100};
`;
export const GuidaSidebar = ({ children, closeButton, onboarding }) => {
    return (_jsx(Sidebar, { onboarding: onboarding, children: _jsxs(StyledSidebarContent, { children: [children, closeButton && _jsx(GuideFooter, { children: closeButton })] }) }));
};
//# sourceMappingURL=GuidaSidebar.js.map